
import { mapState, mapGetters } from 'vuex'
import SpinnerLoading from 'nh-vue-layout/components/general/spinnerLoading.vue'
export default {
  name: 'Slug',
  components: {
    SpinnerLoading
  },
  layout({ app, route }) {
    const props = route.matched[0].props.default
    return props && 'layout' in props && props.options.layout !== '' ? props.options.layout : 'default'
  },
  props: {
    options: {
      type: Object,
      required: false,
      default: () => {}
    },
    pageId: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  fetch() {
    this.$store.dispatch('getAkamaiData')
    this.$store.dispatch('getUserProfile')
    const arrayEngineIdPage = this.pageId
    const view = this.options.view
    const engineContent = this.contentEngine
    const idContentPage = engineContent ? this.getContentPageId(this.userData, engineContent) : null

    if (idContentPage) {
      this.$store.dispatch('getContent', { type: 'pages', idPage: idContentPage })
      this.$store.commit('SET_LOADED', { type: 'engine', value: true })
    } else {
      this.$store.dispatch('getEngineContent', {
        type: 'engine',
        arrayIdPage: arrayEngineIdPage,
        view,
        userData: this.userData,
        idContentPage
      })
    }
  },
  data: () => ({
    dynamic: null,
    brand: process.env.brand,
    environmentName: process.env.environmentName,
    stopDetectAdblock: false
  }),
  computed: {
    ...mapState(['status', 'error', 'contentPage']),
    ...mapState('pages', ['contentPageId']),
    ...mapGetters(['isAuthenticated']),
    ...mapGetters('pages', ['getContentEngine']),
    ...mapGetters('pages', ['getMainConfig']),
    ...mapGetters(['getloadSeoOnce']),
    mainConfig() {
      return this.getMainConfig(this.$i18n.locale)
    },
    liveLocalCategoryId() {
      return this.$modulesConfig.liveLocalCategory[this.environmentName]
    },
    contentEngine() {
      return this.getContentEngine(this.options.view)
    },
    userData() {
      const data = this.isAuthenticated ? this.$auth.getPayload() : {}
      // Default values just in case the program or category is not defined
      if (!data.programs[0]) {
        data.programs[0] = 'GHA_DISCOVERY'
      }
      if (!data.category) {
        data.category = 'SILVER'
      }
      return this.isAuthenticated ? data || {} : {}
    },
    langPage() {
      return this.$i18n?.locales ? this.$i18n?.locales?.filter((data) => data.code === this.$i18n.locale)[0]?.name?.toLowerCase() : ''
    }
  },
  watch: {
    status(newValue) {
      return newValue
    },
    contentPage(newValue) {
      this.$Datalayer.setDatalayer(this.options.view, { content: this.contentPage, mainConfig: this.mainConfig })
    },
    isAuthenticated(newValue) {
      if (!newValue) {
        const url = this.$i18n.locale ? `/${this.$i18n.locale}` : '/'
        window.location.href = url
      }
    },
    mainConfig() {
      this.appendScripts()
    }
  },
  async beforeCreate() {
    await this.$store.dispatch('isAuthenticated', this.$auth.isAuthenticated())
    // eslint-disable-next-line nuxt/no-globals-in-created
    if (!this.isAuthenticated) {
      const url = this.$i18n.locale ? `/${this.$i18n.locale}` : '/'
      window.location.href = url
    }
    await this.$store.dispatch('livelocal/getLiveLocalCategories', { categoryId: this.liveLocalCategoryId })
  },
  mounted() {
    if (!this.$lodash.isEmpty(this.mainConfig)) this.appendScripts()
  },
  created() {
    this.dynamic = () => import(`@/components/pages/${this.options.view}.vue`)
  },
  methods: {
    getContentPageId(userData, engineContent) {
      return engineContent.program
        .find((element) => element.program === userData.programs[0])
        .pagesByCategory.find((element) => element.category === userData.category).pageId
    },
    detectAdblock() {
      let fakeAd = document.createElement('div')
      fakeAd.className = 'textads banner-ads banner_ads ad-unit ad-zone ad-space adsbox'
      fakeAd.style.height = '1px'
      document.body.appendChild(fakeAd)
      let x_width = fakeAd.offsetHeight
      if (x_width) {
        // console.log('No AdBlocker Detected');
      } else {
        this.$EventsGA4.trackEvent('detect_adblock', {
          content: this.contentPage,
          pageLang: this.page_lang
        })
        this.stopDetectAdblock = true
      }
    },
    appendScripts() {
      const isloaded = this.getloadSeoOnce() || false

      if (!isloaded) {
        const jquery = '//code.jquery.com/jquery-3.5.1.min.js'
        const tealium = process.env.environment.tealium?.desktopURL
        const qubit = this.mainConfig.optimizelyLive?.split('src=')[1].split('"')[1]

        const scriptJQuery = document.createElement('script')
        scriptJQuery.setAttribute('src', jquery)
        const scriptTealium = document.createElement('script')
        scriptTealium.setAttribute('src', tealium)
        const scriptQubit = document.createElement('script')
        scriptQubit.setAttribute('src', qubit)

        document.body.appendChild(scriptJQuery)
        document.body.appendChild(scriptTealium)
        document.body.appendChild(scriptQubit)

        this.$store.commit('setloadSeoOnce')
      } else {
        if (utag) utag.view()
      }
    }
  },
  head() {
    if (this.contentPage && this.status) {
      return this.contentPage ? this.$seo.mountedSeo(this.contentPage) : undefined
    }
  },
  updated() {
    if (!this.stopDetectAdblock) {
      this.detectAdblock()
    }
  }
}
